import script from "./AltLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./AltLogo.vue?vue&type=script&setup=true&lang=js"

import "./AltLogo.vue?vue&type=style&index=0&id=a3f662c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3f662c0"]])

export default __exports__